<template>

  <div ref="konto-form"
       class="konto--form">

    <div class="primary--text semanticsection-title2">Kontoverbindung</div>

    <div class="section">

      <v-text-field v-model="iban"
                    v-validate="'required|iban-validator'"
                    :error-messages="errors.collect('iban')"
                    data-vv-as="IBAN"
                    name="iban"
                    label="IBAN"
                    placeholder="DE00 0000 0000 0000 0000 00"
                    mask="AA## #### #### #### #### #### #### #### #### #####"
                    class="required"
                    autocorrect="off"
                    spellcheck="false" />

      <template v-if="$helpers.isIbanAusland(iban)">

        <v-text-field v-show="true"
                      v-model="bic"
                      v-validate="'required|bic-validator'"
                      :error-messages="errors.collect('bic')"
                      data-vv-as="BIC"
                      name="bic"
                      label="BIC"
                      hint="Bitte geben Sie für ausländische Konten die BIC ein."
                      class="required" />

      </template>

      <v-row no-gutters>

        <v-col cols="12"
               sm="6">
          <label class="dmb-form-text">Versicherungsnehmer ist Beitragszahler und Kontoinhaber?*</label>
        </v-col>

        <v-col cols="12"
               sm="6">
          <v-radio-group v-model="inhabertyp"
                         v-validate="'required'"
                         :error-messages="errors.collect('inhabertyp')"
                         data-vv-as="Kontoinhaber"
                         data-vv-name="inhabertyp"
                         name="inhabertyp"
                         class="inhabertyp-rb no-errors-group"
                         row>

            <v-radio label="Ja"
                     value="VN"
                     color="primary" />

            <v-radio label="Nein"
                     value="AK"
                     color="primary" />

          </v-radio-group>
        </v-col>

      </v-row>
    </div>

    <template v-if="inhabertyp==='AK'">

      <div class="primary--text semanticsection-title2">Kontoinhaber</div>

      <konto-inhaber :state-path="statePath + '.kontoinhaber'"
                     form-ref="kontoinhaber-form" />

    </template>

  </div>
</template>

<script>
import KeyTranslator from "@/components/helper/keyTranslatorMixin";
import ValidationMixin from "@/components/helper/ValidationMixin";
import KontoInhaber from "@/components/privatkundenrechner/Person.vue";
import {mapTwoWay} from "@/store/twowayBindingMixin";
import twowayBinding from "@/store/twowayBindingMixin";
export default {
  components: { KontoInhaber },
  mixins: [ValidationMixin, KeyTranslator, twowayBinding],
  props: {
    formRef: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapTwoWay([
      "iban",
      "bic",
      "inhabertyp"])
  }
};
</script>

<style>
.konto--form .v-icon {
  cursor: pointer;
}

.konto--form .dmb-form-text {
  font-size: 16px;
}

.konto--form .inhabertyp-rb {
  padding-top: 0 !important;
}

.konto--form .section {
  margin: 0 !important;
  overflow: auto;
}
</style>

